"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminableFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var AdminableFactory = /** @class */ (function (_super) {
    __extends(AdminableFactory, _super);
    function AdminableFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    AdminableFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    AdminableFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    AdminableFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    AdminableFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    AdminableFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return AdminableFactory;
}(contracts_1.ContractFactory));
exports.AdminableFactory = AdminableFactory;
var _abi = [
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50610117806100206000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c80636e9960c314602d575b600080fd5b60336047565b604051603e919060c8565b60405180910390f35b600060737fb53127684a568b3173ae13b9f8a6016e243e63b6e8ee1178d6a717850b5d610360001b607b565b60001c905090565b6000808254905080915050919050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b600060b482608b565b9050919050565b60c28160ab565b82525050565b600060208201905060db600083018460bb565b9291505056fea2646970667358221220d27ba2b4a9aa9d0c7ca07a9987630af4e10f258a028877a08d6da0a95dcc5db764736f6c634300080a0033";
